<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" :id="id">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header text-white bg-dark">
                    <h5 class="modal-title text-danger">
                        <i class="fas fa-bug"></i>
                        執筆ログ追加
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-show="!isLoading">
                    <div class="mb-3">
                        <h4>{{section.section_name}}</h4>
                    </div>
                    <div class="mb-3">
                        <h5 class="text-right">
                            {{$filters.numberFormat(section.characters)}} 文字
                        </h5>
                    </div>
                    <div class="mb-3">
                        <div class="row">
                            <div class="col">
                                <label>執筆文字数</label>
                                <input type="number" class="form-control nospin" v-model="writing.written_characters">
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label>日付</label>
                        <datepicker
                            placeholder="執筆日"
                            :month-change-on-scroll="false"
                            format="yyyy-MM-dd"
                            :clearable="true"
                            :auto-apply="true"
                            :time-picker="false"
                            :hide-navigation="['time']"
                            model-type="yyyy-MM-dd"
                            v-model="writing.written_date"></datepicker>
                    </div>
                    <div class="small text-muted">
                        <div class="log" v-for="l in logs" :key="l.id">
                            {{$filters.dateFormat(l.written_date, 'YYYY年MM月DD日(dd)')}} - {{$filters.numberFormat(l.written_characters)}} 文字
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="save()">保存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
export default {
    components: {
        Datepicker
    },
    props: {
        id: {
            default: "debug-modal"
        },
        section_id: {
            default: null,
        }
    },
    data() {
        return {
            section: {
                book_id: this.$route.params.book_id,
                section_name: "",
                plot: "",
                is_finish: false,
            },
            writing: {},
            logs: [],
            isLoading: true,
        }
    },
    methods: {
        load() {
            this.isLoading = true;
            axios.get(`/mypage/book/section/get`, { params: {
                'id': this.section_id,
                'book_id': this.$route.params.book_id,
            }}).then(res => {
                this.section = res.data;
                this.isLoading = false;
            }).catch(err => { alert.err(err.response) });
            axios.get(`/mypage/book/writings/get`, { params: {
                'id': this.section_id,
                'book_id': this.$route.params.book_id,
            }}).then(res => {
                this.logs = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        save() {
            axios.post("/mypage/book/plot/debug", this.writing).then(res => {
                alert.msg(res.data);
                this.$emit("saved", this.section.id ? null : true);
                $("#" + this.id).modal("hide");
            }).catch(err => { alert.err(err.response) });
        }
    },
    computed: {
        today() {
            return {
                dates: [
                    new Date()
                ]
            }
        },
    },
    mounted() {
        $("#" + this.id).on("show.bs.modal", (e) => {
            this.writing = {
                book_id: this.$route.params.book_id,
                section_id: this.section_id,
                initial_characters: 0,
                written_characters: 0,
                written_date: moment().format("YYYY-MM-DD"),
            };
            this.load();
        });
    }
}
</script>